<template>
    <swiper 
    v-bind="getSwiperParameters" 
    class="swiper-container"
    
    
    >
        <swiper-slide v-for="(item, i) in dataSlides" :key="i" >
            <img class="swiper-slide-image swiper-gl-image" :src="item.img" crossorigin="anonymous" :style="`object-position:${item.position !=='' ? item.position : 'center'}`"/>

            <div class="swiper-slide-content">
                <div class="flex flex-row justify-end items-center lg:items-baseline swiper-item-content absolute left-0 right-0 container">
                   
                    <div v-if="item.link && item.link !=='#' " class="swiper-slide-link">
                        <button
                        @click="setUrl(item.link)"
                        class="text-1.6rem px-8 py-3 mt-6 border border-white max-w-md rounded-4rem hover:bg-white text-white hover:text-black m-auto "
                        >Scheda Artista</button>
                    </div>
                </div>
            </div>
        </swiper-slide>
    </swiper>
</template>

<script>
import {ref} from "vue";
import { Swiper, SwiperSlide} from "swiper/vue";
import { EffectFade, A11y, Autoplay, Navigation } from "swiper";
import SwiperGL from "./swiper-gl.esm.js";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/a11y";
import "swiper/css/autoplay";
import "swiper/css/navigation";
//import "./swiper-gl.css";
import "./MySwiper.css";

export default {
    name: 'primary-slide',
    components: {
        Swiper,
        SwiperSlide,
    },
    props: {
        dataSlides: {
            type: Array,
            default: []
        },
        effect: {
            type: String,
            default: 'gl'
        },
        gl:{
            type:Object,
            default:  { shader : 'squares'}
        },
        config:{
            type:Object,
            default: null,
        }
    },
    
    computed: {
        getSwiperParameters() {
            const objectRawProps = {...this.config}
            const {effect, navigation} = objectRawProps
            console.log(navigation)
            return {
                modules: [A11y, Autoplay, Navigation,EffectFade, SwiperGL],
                gl: { shader: "squares" },
                speed: 1200,
                effect: effect ? effect : 'gl', 
                navigation: navigation,
                autoplay: { enabled: true },
            }
        },
       
    },
    methods:{
        setUrl(link){
            window.location.href=link
        },
       /* getPosition(index){
         return this.dataSlides[index].position   
        }*/
    }
}
</script>

<style lang="scss" scoped>
.swiper-container {
    height: 100%;
    width: 100%;
    .swiper-slide{
        &-item-content{
            
        }
        &-title{
        bottom:60px;
            @screen mdr{
                font-size:3rem;
            }
        }
        &-link{
            button{
                height:4rem;
                width:16rem;
            }
        
        }
    }
}

/*
.swiper-container .slide-background {
    width:100%;
    height:100%;
}

.swiper-container .slicer div {
    position: absolute;
    z-index: 1;
    background-repeat: no-repeat;

    transform-origin: bottom;
    transition: all 0.6s cubic-bezier(0.71, 0.05, 0.09, 0.91);
    z-index: 100;
}
.slice.active-transition div{
    transform: rotateY(-89deg);
}*/
</style>